const article = {
    id: 'live-shoot-bay-filter',
    title: 'Live Shoot bay filter and column hints',
    summary: 'Filter Live Shoot by bay email, hover column titles for what the counts mean, and keep the page updating.',
    publishedAt: '2026-09-22',
    tags: ['live shoot', 'bay'],
    sections: [
        {
            type: 'paragraph',
            text: 'Live Shoot can be narrowed to one bay, and the stat titles explain Reshoot and QC done. Turn on Keep updating if you want the numbers to refresh while the page stays open.',
        },
        { type: 'heading', text: 'When to use' },
        {
            type: 'paragraph',
            text: 'Use the bay email filter when you are checking one photographer. Use the hints when a count is easy to misread, especially Reshoot versus QC done.',
        },
        { type: 'heading', text: 'How to use' },
        {
            type: 'steps',
            items: [
                'Open Live Shoot.',
                'Type a bay email in the Bay email box to limit the table.',
                'Hover a column title to read what that count includes.',
                'Turn on Keep updating in the toolbar if you want the stats to refresh on their own.',
            ],
        },
        {
            type: 'note',
            text: 'Reshoot means Raw QC sent the SKU back to the last bay because shots were missed. QC done means Raw QC finished that SKU for the bay, including when remaining shoot types move to another bay.',
        },
    ],
};

export default article;
